module.exports = __webpack_public_path__ + "media/images/common/tel_banner-a10cd1229ee9b70cf0b9bbe9b93f9141.png";